// Importing react modules
import styled from "@emotion/styled/macro";
import React from "react";
import ReactGA from "react-ga";

import ButtonBase from "./ButtonBase";
import icon from "../../res/btn_bobble_straight.svg";

const Button = styled(ButtonBase)`
  &:before {
    background-image: url(${icon});
  }
  &:after {
    content: "Straighten";
  }
`;

const StraightenButton = ({ onClick, ...rest }: any) => (
  <Button
    {...rest}
    onClick={() => {
      ReactGA.event({
        category: "bobblehead interaction",
        action: "straighten bobblehead"
      });
      onClick();
    }}
    onMouseDown={event => event.stopPropagation()}
  />
);

export default StraightenButton;
